import Footer from "../src/assets/pages/layout/Footer";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import Index from "./assets/pages/router";
import GoogleTranslateComponent from "./assets/components/GoogleTranslateComponent";

import "./i18n";
import "./App.css";
import "../src/assets/css/style.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      {/* <BrowserRouter basename="/projects/debarati/arghya/GS3/GS3_Webportal/"> */}
      <BrowserRouter basename="/">
        <ToastContainer />
        <GoogleTranslateComponent />
        <Index />
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
